import { Alert, Flex } from 'antd';
import { useLoginGoogleMutation } from 'api/AuthApi';
import googleLogoImage from 'assets/google-icon-logo.svg';
import { useSelector } from 'react-redux';
import { removeAffiliateCode, selectAffiliateCode } from 'store/affiliateSlice';
import { useAppDispatch } from 'store/store';
import { logging } from 'utils/utils';
import './SocialLogin.css';

function SocialLogin() {
  const dispatch = useAppDispatch();
  const affiliateCode = useSelector(selectAffiliateCode);

  const [loginGoogle, { isError: isErrorGoogle, error: errorGoogle }] = useLoginGoogleMutation();

  const handleGoogleResponse = async (response: google.accounts.oauth2.TokenResponse) => {
    try {
      await loginGoogle({
        accessToken: response.access_token,
        origin: window.location.origin,
        partnerCode: affiliateCode
      }).unwrap();

      dispatch(removeAffiliateCode());
    } catch (e) {
      logging(e);
    }
  };

  const googleLogin = () => {
    const client = google.accounts.oauth2.initTokenClient({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID!,
      scope: [
        'https://www.googleapis.com/auth/userinfo.email',
        'https://www.googleapis.com/auth/userinfo.profile'
        // 'https://www.googleapis.com/auth/user.birthday.read',
        // 'https://www.googleapis.com/auth/user.gender.read'
      ].join(' '),
      callback: handleGoogleResponse
    });
    client.requestAccessToken();
  };

  return (
    <div className="social-login">
      {isErrorGoogle && (
        <Alert className="message" message={(errorGoogle as any)?.data?.message} type="error" showIcon />
      )}

      <Flex vertical={true} justify="center" gap="middle">
        <div className="social-login-button google" onClick={googleLogin}>
          <img src={googleLogoImage} alt="" width={20} height={20} /> Continue with Google
        </div>
      </Flex>
    </div>
  );
}

export default SocialLogin;
